// Used on templates page to reorder templates by filter
import Shuffle from 'shufflejs';

function init() {
  const element = document.querySelector('.js-shuffle-container');

  if (element) {
    const sizer = element.querySelector('.js-sizer-element');

    const shuffleInstance = new Shuffle(element, {
      itemSelector: '.template-card',
      sizer,
      speed: 400,
    });

    // Filters
    const filters = document.querySelectorAll('.js-filter-options button');
    const currentlySearching = document.querySelector('.js-currently-searching');
    // This code allows for filtering on mobile
    // let mobileSwiper = document.querySelector('.swiper-templates-page');
    // let mobileSwiperTemplates = document.querySelectorAll('.swiper-templates-page .swiper-slide');

    filters.forEach(filter => {
      filter.addEventListener('click', () => {
        const { group } = filter.dataset;

        if (group === 'showing-all') {
          shuffleInstance.filter(Shuffle.ALL_ITEMS);
        } else {
          shuffleInstance.filter([group]);
        }

        const searchingBy = group.replace(/-/g, ' ');
        currentlySearching.innerHTML = searchingBy.charAt(0).toUpperCase() + searchingBy.slice(1);

        // This code allows for filtering on mobile
        // let index = 0;
        // // Always 0 as always deleting from the beginning
        // mobileSwiperTemplates.forEach(template => {
        //     mobileSwiper.swiper.removeSlide(0);
        // });

        // mobileSwiperTemplates.forEach(template => {
        //     if (group === 'showing-all') {
        //         mobileSwiper.swiper.appendSlide(template);
        //     } else {
        //         if (template.dataset.groups.includes(group)) {
        //             mobileSwiper.swiper.appendSlide(template)
        //         }
        //     }
        // });

        // mobileSwiper.swiper.update()
      });
    });
  }
}

(() => {
  init();
})();
